import { render, staticRenderFns } from "./BiTable.vue?vue&type=template&id=4f231a50&scoped=true&"
import script from "./BiTable.vue?vue&type=script&lang=js&"
export * from "./BiTable.vue?vue&type=script&lang=js&"
import style0 from "./BiTable.vue?vue&type=style&index=0&id=4f231a50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f231a50",
  null
  
)

export default component.exports